import { render, staticRenderFns } from "./BadReviews.vue?vue&type=template&id=7381476a&scoped=true&"
import script from "./BadReviews.vue?vue&type=script&lang=js&"
export * from "./BadReviews.vue?vue&type=script&lang=js&"
import style0 from "./BadReviews.vue?vue&type=style&index=0&id=7381476a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7381476a",
  null
  
)

export default component.exports